import { motion } from "framer-motion";
import { useTranslation } from "../i18n/LanguageContext";

export default function FounderSection() {
  const { t } = useTranslation();
  const f = t.founder;

  return (
    <section
      id="about"
      className="py-24 md:py-32 bg-[#0A0A0B]"
      data-testid="founder-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="mb-12"
        >
          <div className="flex items-center gap-4">
            <motion.span
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, ease: "easeOut" }}
              className="inline-block w-10 h-px bg-[#C9A96E]"
              style={{ transformOrigin: "left center" }}
            />
            <span className="fwd-eyebrow" data-testid="founder-eyebrow">
              {f.eyebrow}
            </span>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14 items-start">
          {/* LEFT COLUMN — 35% (md:col-span-4) — Photo + Name + LinkedIn + Credentials */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className="md:col-span-4"
            data-testid="founder-meta"
          >
            <div
              className="overflow-hidden mb-6"
              style={{ border: "1px solid #2A2A2E", borderRadius: "2px" }}
            >
              <img
                src="/Forbes_Profile_Pic.jpg"
                alt="Juan Roberto Martinez, Founder of FWDCO Group"
                className="w-full h-auto block"
                loading="lazy"
              />
            </div>

            <h3 className="fwd-heading mb-2" data-testid="founder-name">
              {f.name}
            </h3>
            <p
              className="mb-5"
              style={{
                fontFamily: "Montserrat, sans-serif",
                fontSize: "16px",
                fontWeight: 600,
                color: "#C9A96E",
              }}
              data-testid="founder-role"
            >
              {f.role}
            </p>

            <a
              href={f.linkedinUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mb-6 transition-colors hover:text-[#F5F1E8]"
              style={{
                fontFamily: "Montserrat, sans-serif",
                fontSize: "16px",
                fontWeight: 400,
                color: "#B8B8C0",
              }}
              data-testid="founder-linkedin"
              aria-label={f.linkedinLabel}
            >
              <img
                src="/Logo_LinkedIn.png"
                alt="LinkedIn"
                style={{ height: "20px", width: "auto" }}
              />
              <span>LinkedIn</span>
            </a>

            <p className="fwd-body" data-testid="founder-credentials">
              {f.credentials}
            </p>
          </motion.div>

          {/* RIGHT COLUMN — 65% (md:col-span-8) — Letter */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15, ease: "easeOut" }}
            className="md:col-span-8"
            data-testid="founder-letter"
          >
            <h2 className="fwd-heading mb-10" data-testid="founder-quote">
              "{f.quoteLead}{" "}
              <span className="fwd-italic-gold">{f.quoteItalic}</span>"
            </h2>

            <div className="space-y-6">
              {f.paragraphs.map((p, i) => (
                <p key={i} className="fwd-body" data-testid={`founder-paragraph-${i}`}>
                  {p}
                </p>
              ))}
            </div>

            <div
              className="mt-10 pt-8"
              style={{ borderTop: "1px solid #2A2A2E" }}
            >
              <p className="fwd-italic-gold mb-2" data-testid="founder-motto">
                {f.signatureMotto}
              </p>
              <p
                style={{
                  fontFamily: "Montserrat, sans-serif",
                  fontSize: "16px",
                  fontWeight: 400,
                  color: "#B8B8C0",
                }}
                data-testid="founder-signature"
              >
                <span style={{ color: "#F5F1E8" }}>{f.name}</span>, {f.role}
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
